import * as React from "react";

export function DotSeparatorIcon({ className }: { className?: string }) {
  return (
    <svg className={className} width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.576 4.4C3.648 4.4 4.368 3.648 4.368 2.608C4.368 1.552 3.648 0.783999 2.576 0.783999C1.504 0.783999 0.8 1.552 0.8 2.608C0.8 3.648 1.504 4.4 2.576 4.4Z" fill="#545454" />
    </svg>
  );
}
